module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/crypto-app-1-742a794fd1d3a14f31cbb4b31a2d1d64.png";